import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
import { Leaf } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { exchangeGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Synchronous guard to prevent double-execution under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      // Parse session_id from URL fragment
      const hash = location.hash || window.location.hash;
      const params = new URLSearchParams(hash.replace(/^#/, ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        toast.error('Missing session ID');
        navigate('/login', { replace: true });
        return;
      }

      try {
        await exchangeGoogleSession(sessionId);
        // Clear the hash and navigate to dashboard
        window.history.replaceState(null, '', window.location.pathname);
        toast.success('Signed in with Google!');
        navigate('/dashboard', { replace: true });
      } catch (error) {
        toast.error('Google sign-in failed. Please try again.');
        navigate('/login', { replace: true });
      }
    };

    processCallback();
  }, [location.hash, exchangeGoogleSession, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#F4F4F0]" data-testid="auth-callback">
      <div className="w-16 h-16 bg-[#2E4632] rounded-full flex items-center justify-center mb-4">
        <Leaf className="w-8 h-8 text-white" />
      </div>
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#2E4632] mb-4"></div>
      <p className="text-[#5C5C5C] font-medium">Completing sign-in...</p>
    </div>
  );
};

export default AuthCallback;
